import locations from "./locations.js";

export default {
  namespaced: true,
  state: {
    all: [],
    loading: false,
    // Application and Eligibility Counts
    counts: {},
  },
  modules: {
    locations,
  },
  getters: {
    all: (state) => state.all,
    find:
      (state) =>
      (id = Vue.$route.params.id) =>
        state.all.find((opportunity) => opportunity.id == id),
    loading: (state) => state.loading,
    orderedPhases:
      (state, getters) =>
      (id = Vue.$route.params.id) => {
        const opportunity = getters.find(id);
        if (opportunity && opportunity.phases && opportunity.phases[0]) {
          let order = 1;
          let current = opportunity.phases.find((p) => p.initial);
          let phases = [
            {
              id: current.id,
              name: current.name,
              description: current.description,
              order,
            },
          ];

          while (current.next) {
            current = opportunity.phases.find(
              (p) => p.name == current.next.name
            );
            order++;
            phases.push({
              id: current.id,
              name: current.name,
              description: current.description,
              order,
            });
          }
          return phases;
        }
        return [];
      },
    currentIsManager:
      (state, getters, rootState) =>
      (id = Vue.$route.params.id) => {
        const opportunity = getters.find(id);
        return (
          rootState.auth.user.primary ||
          (opportunity &&
            opportunity.managers &&
            opportunity.managers.some((m) => m.id === rootState.auth.user.id))
        );
      },
  },
  mutations: {
    setAll(state, opportunities) {
      state.all = opportunities;
      state.loading = false;
    },
    set(state, opportunity) {
      state.all = state.all.filter((o) => o.id != opportunity.id);
      state.all.push(opportunity);
    },
    setCounts(state, counts) {
      state.counts = Object.assign({}, state.counts, counts);
    },
    startLoading(state) {
      state.loading = true;
    },
    stopLoading(state) {
      state.loading = false;
    },
  },
  actions: {
    fetchCounts({ commit, state }, { opportunity, filters = {} } = {}) {
      opportunity = opportunity || Vue.$route.params.id;
      state.counts = {};

      return Vue.$http
        .get(`client/opportunities/${opportunity}/counts`, {
          params: { opportunity, ...filters },
        })
        .then((response) => commit("setCounts", response.data));
    },
    fetchAll({ commit }) {
      commit("startLoading");
      return Vue.$http.get("client/opportunities").then(
        (response) => commit("setAll", response.data),
        (response) => commit("stopLoading")
      );
    },

    fetch({ commit, getters }, id = Vue.$route.params.id) {
      const opportunity = getters.find();

      if (opportunity) {
        commit("set", Object.assign(opportunity, { loading: true }));
      } else {
        commit("set", { id, loading: true });
      }

      return Vue.$http.get(`client/opportunities/${id}`).then((response) => {
        return commit("set", Object.assign(response.data, { loading: false }));
      });
    },

    update({ commit }, opportunity) {
      return Vue.$http
        .patch(`client/opportunities/${opportunity.id}`, { opportunity })
        .then(
          ({ data }) => commit("set", data),
          (errors) => errors
        );
    },
  },
};
